import { allFonts, fontLabelOf, pickerFonts } from '@messenger/lotus/fonts'

export const EDITOR_FONT_FAMILIES: readonly string[] = pickerFonts.map(
  (f) => f.name,
)

const LABELS: ReadonlyMap<string, string> = new Map(
  allFonts.map((f) => [f.name, fontLabelOf(f)]),
)

export const fontDisplayLabel = (family: string): string =>
  LABELS.get(family) ?? family
